
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { PageHeadline } from '@/components/atom/PageHeadline';
import { CreateOrderCard } from '@/components/exchange/CreateOrderCard';
import { OrdersCard } from '@/components/exchange/OrdersCard';
import { MAINNET } from '@/constants/env';
import { useExchangeBalance } from '@/hooks/exchange/balance';
import { useClayExchangeData } from '@/hooks/exchange/clayexchange';
import { usePolling } from '@/hooks/polling';
import { useTranslation } from '@/hooks/support/translate';
import styles from '@/styles/Global.module.css';
import classNames from 'classnames';
import Head from 'next/head';
import { useState } from 'react';
import { useEvent } from 'react-use';
import WhitelistModal from '@/components/game/WhitelistModal';

const Exchange = () => {
    const [isScreenVisible, setIsScreenVisible] = useState(false);
    useExchangeBalance();
    useClayExchangeData();
    usePolling(isScreenVisible);
    const { t } = useTranslation();
    const testnetTitle = !MAINNET ? `${t('common.testnet')} ` : '';
    const title = `ClayStack ${testnetTitle}| ${t('common.title')}`;

    // Set Focus on page for Polling hook
    const handlePageVisibility = async () => {
        const isVisible = document.hasFocus();
        setIsScreenVisible(isVisible);
    };
    useEvent('visibilitychange', handlePageVisibility);

    return (
        <>
            <Head>
                <title>{title}</title>
            </Head>
            <div className={styles.page}>
                <div
                    className={classNames(
                        'flex flex-col items-center justify-center w-full px-4 pt-12 my-auto xl:px-0',
                    )}
                >
                    <div className="fixed top-0 z-[-1] exchange-gradient"></div>
                    <PageHeadline
                        title={'Exchange Liquid Tokens'}
                        caption={'Exchange your liquid tokens for native tokens in marketplace'}
                        align="center"
                    />
                    <WhitelistModal>
                        <div className="flex flex-col mb-8 lg:px-4 xl:px-12 lg:space-x-8 lg:flex-row">
                            <div className="lg:w-1/2 xl:px-12">
                                <CreateOrderCard />
                            </div>
                            <div className="lg:w-1/2 xl:px-8">
                                <OrdersCard />
                            </div>
                        </div>
                    </WhitelistModal>
                </div>
            </div>
        </>
    );
};

export default Exchange;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        
// @ts-ignore
        
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          
// @ts-ignore
          props: {
// @ts-ignore
            
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/exchange',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  